import { Admin } from "models/admin";
import { doGet, doPatch, doPost } from "../request";

export interface AdminLoginResponse {
  accessToken: string;
  refreshToken: string;
  admin: Admin;
}

export const adminDoPostLogin = async (email: string, password: string) => {
  return doPost<AdminLoginResponse>("/admin/login", { email, password });
};

export const adminDoGetAdmins = async () => {
  return doGet<Admin[]>("/admin/settings/admins");
};

export const adminDoGetAdmin = async (adminUuid: string) => {
  return doPost<Admin>(`/admin/settings/admin/${adminUuid}`);
};

export const adminDoPostAdmin = async (data: Partial<Admin>) => {
  return doPost<Admin>("/admin/settings/admin", data);
};

export const adminDoPatchAdmin = async (
  adminUuid: string,
  data: Partial<Admin>,
) => {
  return doPatch<Admin>(`/admin/settings/admin/${adminUuid}`, data);
};

export const adminDoPatchAdminDisable = async (admin: Admin) => {
  if (admin.active === true) {
    return doPatch(`/admin/settings/admin/${admin.uuid}/disable`);
  }
};

export const adminDoPatchAdminEnable = async (admin: Admin) => {
  if (admin.active === false) {
    return doPatch(`/admin/settings/admin/${admin.uuid}/enable`);
  }
};
